var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Eduardo Robles <edu@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import styled from "@emotion/styled";
import { IconButton } from "@mui/material";
import { adminTheme } from "@sequentech/ui-essentials";
import { useRecordContext } from "react-admin";
export var ActionsColumn = function (props) {
    var record = useRecordContext();
    var actions = props.actions;
    var StyledIconButton = styled(IconButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: ", ";\n        font-size: 18px;\n        margin-left: 8px;\n    "], ["\n        color: ", ";\n        font-size: 18px;\n        margin-left: 8px;\n    "])), adminTheme.palette.brandColor);
    var filteredActions = actions.filter(function (action) { return !action.showAction || action.showAction(record.id); });
    return (_jsx(_Fragment, { children: filteredActions && filteredActions.length > 0
            ? filteredActions.map(function (action, index) {
                var _a;
                return (_jsx(StyledIconButton, __assign({ className: (_a = action.className) !== null && _a !== void 0 ? _a : "", onClick: function () { return action.action(record.id); } }, { children: action.icon }), index));
            })
            : null }));
};
var templateObject_1;
